'use client';

import { useQuery } from '@tanstack/react-query';
import { getPlayback, PlaybackType } from '@vimond/services/play';
import { useAuthentication } from '../../authentication';
import { useSubprofiles } from '../../subprofiles';

export const usePlayback = (
  assetId: string,
  userAgent: string,
  initialDataProp?: PlaybackType,
) => {
  const { jwt } = useAuthentication();
  const { subprofileToken } = useSubprofiles();
  const cacheKey = ['play', assetId];
  if (jwt) cacheKey.push(jwt);
  if (subprofileToken) cacheKey.push(subprofileToken);

  const initialData = initialDataProp && { data: [initialDataProp] };
  const {
    data,
    error: loadingError,
    isLoading,
  } = useQuery({
    queryKey: cacheKey,
    queryFn: async () => {
      const result =
        (await getPlayback(assetId, userAgent, jwt, subprofileToken)) || null;
      return result;
    },
    initialData,
    enabled: !!assetId,
    refetchOnWindowFocus: false,
  });

  return {
    playback: data?.data?.[0],
    error:
      data?.errors?.[0] ??
      (loadingError
        ? { title: loadingError?.name, code: undefined, dettail: undefined }
        : undefined),
    isLoading,
  };
};
